import { AdKind } from 'constants/ads';
export const transformAdsPlacementOptions = placementOptions => ({
  isSticky: placementOptions.is_sticky
});
export const transformDirectPlacementConfig = placementConfig => ({
  kind: placementConfig.kind,
  shape: placementConfig.shape,
  page: placementConfig.page,
  options: transformAdsPlacementOptions(placementConfig.options),
  segmentIds: placementConfig.segment_ids,
  code: placementConfig.code,
  mediation: placementConfig.mediation
});
export const transformRtbPlacementConfig = placementConfig => ({
  kind: placementConfig.kind,
  shape: placementConfig.shape,
  page: placementConfig.page,
  dfpCode: placementConfig.dfp_code,
  dfpAccountId: placementConfig.dfp_account_id,
  options: transformAdsPlacementOptions(placementConfig.options),
  sizes: placementConfig.sizes,
  bids: placementConfig.bids,
  mediation: placementConfig.mediation
});
export const transformAdsPlacement = placement => {
  if (placement.config.kind === AdKind.Direct) {
    return transformDirectPlacementConfig(placement.config);
  }

  return transformRtbPlacementConfig(placement.config);
};
export const transformAdsPlacements = placements => placements.map(transformAdsPlacement);